module.exports = __webpack_public_path__ + "icon_header_phone.png?c9e1bd19e73c7b31eb417340e06279b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_header_phone.png
// module id = 215
// module chunks = 0